<template>
  <div class="fts-state" :style="{'background-color': model.color}" v-if="model.name">
    <div>{{model.name}}</div>
  </div>
</template>

<script>
import { clientStore } from '../store/clientStore';

export default {
  props: {
    stateId: String,
    state: {
      type: Object,
      default: () => ({
        name: '(unset)'
      })
    },
    options: Array,
  },
  computed: {
    model() {
      const stateId = this.stateId ? this.stateId : this.state.id;
      const findState = this.states.find(x => x.id === stateId)
      if (findState && findState.id) 
        return {
          id: findState.id,
          name: findState.name,
          color: findState.color
        }
      else
        return this.state
    },
    states() {
      return Array.isArray(this.options) ? this.options : clientStore.getters.workspaceStates || [];
    },
  }
}
</script>

<style lang="scss" scoped>
@import "./src/assets/scss/vars.scss";

.fts-state {
  min-width: 1rem;
  max-width: 100%;
  display: inline-flex;
  border-radius: 0.25rem;
  background-color: var(--fts-gray-5);
  cursor: default;
  > div {
    @include text-overflow-ellipsis;
    padding: 0.275rem 0.475rem;
    line-height: normal;
    color: #fff;
    font-size: 0.75rem;
    font-weight: 700;
    cursor: inherit;
  }
  &.fts-state-md {
    > div {
      font-size: 1rem;
    }
  }
}

</style>